import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';
import { EntidadEmpresarial } from 'src/app/services/servicio-resolucion0256.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioNotasEnfermeriaService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEntidadEmpresarial(objetoParametros: ParametrosNotasEnfermeriaEntity, uncoEntidadEmpresarial: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad',
        [objetoParametros.codigoBaseDatos, { unco_entidad_empresarial: uncoEntidadEmpresarial }]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }
}

export interface ParametrosNotasEnfermeriaEntity {
  codigoBaseDatos: string;
  uncoSede: string;
  uncoLogin: number;
  uncoEntidad: string;
}
export interface EntidadEmpresarial {
  unco: number;
  nombreEntidad: string;
  nit: string;
  digitoVerificacion: string;
  direccion: string;
  telefono: string;
}
